import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { AmsFile } from '@core/objects/ams-file';
import { FilesListItemMenuClick } from '../files-list-item-menu-click';

/**
 * component for list of files without notes.
 */
@Component({
    selector: 'core-files-list-default',
    templateUrl: './default.component.html',
    styleUrls: ['./default.component.scss']
})
export class FilesListDefaultComponent implements OnInit {

    @Input() files: Array<AmsFile>;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    
    @Output() actionClick= new EventEmitter<AmsFile>();
    @Output() menuClick = new EventEmitter<FilesListItemMenuClick>();
    @Output() iconDownloadClick = new EventEmitter<AmsFile>();

    ngOnInit() {
    }
}
